import { Link } from "react-router-dom";
import { categories, siteMeta } from "@/mocks/community";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/topics", label: "话题榜" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto grid max-w-container gap-10 px-4 py-14 md:px-6 lg:grid-cols-[1.6fr_1fr_1fr_1fr]">
        <div>
          <Link to="/" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
              <i className="ri-flashlight-fill text-lg" aria-hidden="true" />
            </span>
            <span className="font-heading text-lg font-bold text-background-50">{siteMeta.name}</span>
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">{siteMeta.intro}</p>
          <div className="mt-5 space-y-2 text-sm text-background-200/80">
            <a href={`mailto:${siteMeta.email}`} className="flex items-center gap-2 transition-colors hover:text-accent-300">
              <i className="ri-mail-line" aria-hidden="true" />
              {siteMeta.email}
            </a>
            <p className="flex items-center gap-2">
              <i className="ri-time-line" aria-hidden="true" />
              {siteMeta.workingHours}
            </p>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-semibold tracking-wide text-background-50">快速导航</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-background-200/80 transition-colors hover:text-accent-300">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold tracking-wide text-background-50">内容板块</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {categories.slice(0, 5).map((cat) => (
              <li key={cat.key}>
                <Link
                  to={`/topics?category=${cat.key}`}
                  className="text-background-200/80 transition-colors hover:text-accent-300"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold tracking-wide text-background-50">投稿与规范</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/about#submit" className="text-background-200/80 transition-colors hover:text-accent-300">
                我要爆料
              </Link>
            </li>
            <li>
              <Link to="/about#principles" className="text-background-200/80 transition-colors hover:text-accent-300">
                内容原则
              </Link>
            </li>
            <li>
              <Link to="/faq" className="text-background-200/80 transition-colors hover:text-accent-300">
                常见问题
              </Link>
            </li>
            <li>
              <Link to="/topics" className="text-background-200/80 transition-colors hover:text-accent-300">
                板块热榜
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="mx-auto flex max-w-container flex-col gap-3 px-4 py-6 text-xs text-background-200/70 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>
            © {year} {siteMeta.name} · 内容由用户投稿并经编辑整理，不代表平台立场
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>始于 {siteMeta.foundedAt} 年</span>
            <span className="hidden sm:inline">·</span>
            <span>理性吃瓜，友善讨论</span>
          </p>
        </div>
      </div>
    </footer>
  );
}